
import { useState } from 'react';
import { Link } from 'react-router-dom';

interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  const [mobileOpen, setMobileOpen] = useState(false);

  const scrollToSection = (id: string) => {
    setMobileOpen(false);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || mobileOpen ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="w-10 h-10 bg-emerald-500 rounded-full flex items-center justify-center">
            <i className="ri-leaf-line text-white text-xl"></i>
          </div>
          <div>
            <h1 className={`text-xl font-bold transition-colors ${scrolled || mobileOpen ? 'text-slate-900' : 'text-white'}`}>GREENIFY</h1>
            <p className={`text-xs transition-colors hidden sm:block ${scrolled || mobileOpen ? 'text-emerald-500' : 'text-emerald-300'}`}>Your Gateway to Global Education</p>
          </div>
        </div>

        {/* Desktop nav */}
        <div className="hidden lg:flex items-center gap-8">
          <button
            onClick={() => scrollToSection('services')}
            className={`text-sm font-medium uppercase tracking-wide transition-colors cursor-pointer ${
              scrolled ? 'text-slate-700 hover:text-emerald-500' : 'text-white hover:text-emerald-300'
            }`}
          >
            Services
          </button>
          <button
            onClick={() => scrollToSection('destinations')}
            className={`text-sm font-medium uppercase tracking-wide transition-colors cursor-pointer ${
              scrolled ? 'text-slate-700 hover:text-emerald-500' : 'text-white hover:text-emerald-300'
            }`}
          >
            Destinations
          </button>
          <button
            onClick={() => scrollToSection('process')}
            className={`text-sm font-medium uppercase tracking-wide transition-colors cursor-pointer ${
              scrolled ? 'text-slate-700 hover:text-emerald-500' : 'text-white hover:text-emerald-300'
            }`}
          >
            Process
          </button>
          <button
            onClick={() => scrollToSection('contact')}
            className={`text-sm font-medium uppercase tracking-wide transition-colors cursor-pointer ${
              scrolled ? 'text-slate-700 hover:text-emerald-500' : 'text-white hover:text-emerald-300'
            }`}
          >
            Contact
          </button>
          <Link
            to="/admin-login"
            className={`text-sm font-medium uppercase tracking-wide transition-colors cursor-pointer ${
              scrolled ? 'text-slate-700 hover:text-emerald-500' : 'text-white hover:text-emerald-300'
            }`}
          >
            Login
          </Link>
          <Link
            to="/booking"
            className="px-6 py-2.5 bg-emerald-500 text-white text-sm font-medium rounded-full hover:bg-emerald-600 transition-all whitespace-nowrap cursor-pointer"
          >
            Book Now
          </Link>
        </div>

        {/* Mobile hamburger */}
        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer transition-colors ${
            scrolled || mobileOpen ? 'text-slate-900' : 'text-white'
          }`}
        >
          <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
        </button>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="lg:hidden bg-white border-t border-gray-100 px-4 pb-6 pt-2 space-y-1">
          <button
            onClick={() => scrollToSection('services')}
            className="w-full text-left px-4 py-3 text-sm font-medium text-slate-700 hover:bg-emerald-50 hover:text-emerald-600 rounded-lg transition-colors cursor-pointer"
          >
            Services
          </button>
          <button
            onClick={() => scrollToSection('destinations')}
            className="w-full text-left px-4 py-3 text-sm font-medium text-slate-700 hover:bg-emerald-50 hover:text-emerald-600 rounded-lg transition-colors cursor-pointer"
          >
            Destinations
          </button>
          <button
            onClick={() => scrollToSection('process')}
            className="w-full text-left px-4 py-3 text-sm font-medium text-slate-700 hover:bg-emerald-50 hover:text-emerald-600 rounded-lg transition-colors cursor-pointer"
          >
            Process
          </button>
          <button
            onClick={() => scrollToSection('contact')}
            className="w-full text-left px-4 py-3 text-sm font-medium text-slate-700 hover:bg-emerald-50 hover:text-emerald-600 rounded-lg transition-colors cursor-pointer"
          >
            Contact
          </button>
          <Link
            to="/admin-login"
            onClick={() => setMobileOpen(false)}
            className="block px-4 py-3 text-sm font-medium text-slate-700 hover:bg-emerald-50 hover:text-emerald-600 rounded-lg transition-colors cursor-pointer"
          >
            Login
          </Link>
          <div className="pt-2 px-4">
            <Link
              to="/booking"
              onClick={() => setMobileOpen(false)}
              className="block text-center w-full px-6 py-3 bg-emerald-500 text-white text-sm font-medium rounded-full hover:bg-emerald-600 transition-all whitespace-nowrap cursor-pointer"
            >
              Book Now
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}
